import { Analytics, checkPlacement } from 'client/Global/Analytics'
import { AnalyticsType, Category, Events, Result } from 'client/Global/AnalyticsEvents'
import { Segment } from 'client/Global/Segment'
import { SegmentEvents } from 'client/Global/SegmentEvents'
import { l } from 'client/Other/Translation'
import { useEffect, useState } from 'react'
import * as React from 'react'

export const SelectInvoiceLines = ({ settings, setSettings, changedValues, setChangedValues }) => {
  const [activeButton, setActiveButton] = useState(settings.invoiceHeaderLines)

  useEffect(() => {
    setActiveButton(settings.settings.invoiceHeaderLines)
  }, [settings])

  const handleClick = (headerStyle) => {
    Segment.track(SegmentEvents.invoiceCustomise.invoiceCustomised, { table_header_style_changed: headerStyle })
    setActiveButton(headerStyle)
    setSettings({
      loaded: true,
      modified: true,
      customSettings: {
        ...settings,
        settings: {
          ...settings.settings,
          invoiceHeaderLines: headerStyle,
        },
      },
    })
    setChangedValues({ ...changedValues, headerType: true })
    Analytics.trackEvent(Events.selectColumnHeader, {
      type: AnalyticsType.action,
      category: Category.setting,
      result: Result.success,
      placement: checkPlacement(window.location.pathname),
      headerType: headerStyle,
    })
  }

  return (
    <div className="SelectInput Controlled Input CustomTemplate">
      <span className="Label">{l('customTemplates.invoiceLinesHeader')}</span>
      <div className="BoxContainer">
        <div
          onClick={() => handleClick('underline')}
          className={activeButton === 'underline' ? 'Box Box__1 Box__Active' : 'Box Box__1'}
        ></div>
        <div
          onClick={() => handleClick('background')}
          className={activeButton === 'background' ? 'Box Box__2 Box__Active' : 'Box Box__2'}
        ></div>
        <div
          onClick={() => handleClick('doubleLines')}
          className={activeButton === 'doubleLines' ? 'Box Box__3 Box__Active' : 'Box Box__3'}
        ></div>
      </div>
    </div>
  )
}
